var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-h-100"},[_c('div',{staticClass:"a-w-100 a-h-100 a-bg-white a-plr-25 a-pb-40"},[_c('EarningsTrend',{staticClass:"stationStat a-w-100",attrs:{"id":_vm.id,"params":_vm.params,"infoType":_vm.infoType}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }